import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { ICurrentWorkspaceStore } from '../../../../modules/workspaces/currentWorkspace/CurrentWorkspace.store';
import { ProjectDetailsTabs } from '../components/ProjectDetailsTabs';
import { IProjectDetailsBl } from '../projectDetails.bl';
import { IProjectDetailsActivitiesBl } from '../sub/activityLog/projectDetailsActivities.bl';
import { IImageFilterService } from '../sub/images/services/imageFilters.service';
import { IProjectDetailsToolsBl } from '../sub/tools/projectDetailsTools.bl';

export const ProjectDetailsTabsContainer = observer((): ReactElement => {
  const projectDetailsBl = useInjection(IProjectDetailsBl.$);
  const imageFilterService = useInjection(IImageFilterService.$);
  const projectDetailsToolsBl = useInjection(IProjectDetailsToolsBl.$);
  const projectDetailsActivitiesBl = useInjection(IProjectDetailsActivitiesBl.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);

  const imageClickCallback = async (): Promise<void> => {
    await imageFilterService.setDefaultImagePaging();
  };

  const { id, datasetsStatus, usersStatus, status, imagesStatus } = projectDetailsBl.store;
  const { toolsStatus } = projectDetailsToolsBl.store;
  const { activityLogStatus: activitylogStatus } = projectDetailsActivitiesBl.store;

  return (
    <ProjectDetailsTabs
      imageClickCallback={imageClickCallback}
      projectId={id}
      projectStatus={status}
      workspaceId={currentWorkspaceStore.currentWorkspace.id}
      datasetsStatus={datasetsStatus}
      usersStatus={usersStatus}
      toolsStatus={toolsStatus}
      activityLogStatus={activitylogStatus}
      imagesStatus={imagesStatus}
    />
  );
});
